import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function CorporateCompany(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      sx,
      viewBox,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "CorporateCompany",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24 9c-.2652 0-.5196-.10536-.7071-.29289C23.1054 8.51957 23 8.26522 23 8V3c0-.26522.1054-.51957.2929-.70711C23.4804 2.10536 23.7348 2 24 2c.2652 0 .5196.10536.7071.29289C24.8946 2.48043 25 2.73478 25 3v5c0 .26522-.1054.51957-.2929.70711C24.5196 8.89464 24.2652 9 24 9Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21 12V8c0-.26522.1054-.51957.2929-.70711C21.4804 7.10536 21.7348 7 22 7h4c.2652 0 .5196.10536.7071.29289C26.8946 7.48043 27 7.73478 27 8v4h-6Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M29 16v-4c0-.2652-.1054-.5196-.2929-.7071S28.2652 11 28 11h-8c-.2652 0-.5196.1054-.7071.2929S19 11.7348 19 12v4h10Zm-16 7v-5c0-.2652-.1054-.5196-.2929-.7071S12.2652 17 12 17h-2c-.26522 0-.51957.1054-.70711.2929C9.10536 17.4804 9 17.7348 9 18v5h4Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M5 27v-5c0-.2652.10536-.5196.29289-.7071C5.48043 21.1054 5.73478 21 6 21h12v6H5Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M5 45V25h13v21H6c-.26522 0-.51957-.1054-.70711-.2929C5.10536 45.5196 5 45.2652 5 45Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M13 32c.2652 0 .5196-.1054.7071-.2929S14 31.2652 14 31v-2c0-.2652-.1054-.5196-.2929-.7071S13.2652 28 13 28c-.2652 0-.5196.1054-.7071.2929S12 28.7348 12 29v2c0 .2652.1054.5196.2929.7071S12.7348 32 13 32Zm0 6c.2652 0 .5196-.1054.7071-.2929S14 37.2652 14 37v-2c0-.2652-.1054-.5196-.2929-.7071S13.2652 34 13 34c-.2652 0-.5196.1054-.7071.2929S12 34.7348 12 35v2c0 .2652.1054.5196.2929.7071S12.7348 38 13 38Zm-4-6c.26522 0 .51957-.1054.70711-.2929C9.89464 31.5196 10 31.2652 10 31v-2c0-.2652-.10536-.5196-.29289-.7071C9.51957 28.1054 9.26522 28 9 28s-.51957.1054-.70711.2929C8.10536 28.4804 8 28.7348 8 29v2c0 .2652.10536.5196.29289.7071C8.48043 31.8946 8.73478 32 9 32Zm0 6c.26522 0 .51957-.1054.70711-.2929C9.89464 37.5196 10 37.2652 10 37v-2c0-.2652-.10536-.5196-.29289-.7071C9.51957 34.1054 9.26522 34 9 34s-.51957.1054-.70711.2929C8.10536 34.4804 8 34.7348 8 35v2c0 .2652.10536.5196.29289.7071C8.48043 37.8946 8.73478 38 9 38Zm4 6c.2652 0 .5196-.1054.7071-.2929S14 43.2652 14 43v-2c0-.2652-.1054-.5196-.2929-.7071S13.2652 40 13 40c-.2652 0-.5196.1054-.7071.2929S12 40.7348 12 41v2c0 .2652.1054.5196.2929.7071S12.7348 44 13 44Zm-4 0c.26522 0 .51957-.1054.70711-.2929C9.89464 43.5196 10 43.2652 10 43v-2c0-.2652-.10536-.5196-.29289-.7071C9.51957 40.1054 9.26522 40 9 40s-.51957.1054-.70711.2929C8.10536 40.4804 8 40.7348 8 41v2c0 .2652.10536.5196.29289.7071C8.48043 43.8946 8.73478 44 9 44Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M35 23v-5c0-.2652.1054-.5196.2929-.7071S35.7348 17 36 17h2c.2652 0 .5196.1054.7071.2929S39 17.7348 39 18v5h-4Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M43 27v-5c0-.2652-.1054-.5196-.2929-.7071S42.2652 21 42 21H30v6h13Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M43 45V25H30v21h12c.2652 0 .5196-.1054.7071-.2929S43 45.2652 43 45Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17 46V16c0-.2652.1054-.5196.2929-.7071S17.7348 15 18 15h12c.2652 0 .5196.1054.7071.2929S31 15.7348 31 16v30H17Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M27 20h-6c-.2652 0-.5196-.1054-.7071-.2929S20 19.2652 20 19c0-.2652.1054-.5196.2929-.7071S20.7348 18 21 18h6c.2652 0 .5196.1054.7071.2929S28 18.7348 28 19c0 .2652-.1054.5196-.2929.7071S27.2652 20 27 20Zm0 4h-6c-.2652 0-.5196-.1054-.7071-.2929S20 23.2652 20 23c0-.2652.1054-.5196.2929-.7071S20.7348 22 21 22h6c.2652 0 .5196.1054.7071.2929S28 22.7348 28 23c0 .2652-.1054.5196-.2929.7071S27.2652 24 27 24Zm0 4h-6c-.2652 0-.5196-.1054-.7071-.2929S20 27.2652 20 27c0-.2652.1054-.5196.2929-.7071S20.7348 26 21 26h6c.2652 0 .5196.1054.7071.2929S28 26.7348 28 27c0 .2652-.1054.5196-.2929.7071S27.2652 28 27 28Zm0 4h-6c-.2652 0-.5196-.1054-.7071-.2929S20 31.2652 20 31c0-.2652.1054-.5196.2929-.7071S20.7348 30 21 30h6c.2652 0 .5196.1054.7071.2929S28 30.7348 28 31c0 .2652-.1054.5196-.2929.7071S27.2652 32 27 32Zm0 4h-6c-.2652 0-.5196-.1054-.7071-.2929S20 35.2652 20 35c0-.2652.1054-.5196.2929-.7071S20.7348 34 21 34h6c.2652 0 .5196.1054.7071.2929S28 34.7348 28 35c0 .2652-.1054.5196-.2929.7071S27.2652 36 27 36Zm0 4h-6c-.2652 0-.5196-.1054-.7071-.2929S20 39.2652 20 39c0-.2652.1054-.5196.2929-.7071S20.7348 38 21 38h6c.2652 0 .5196.1054.7071.2929S28 38.7348 28 39c0 .2652-.1054.5196-.2929.7071S27.2652 40 27 40Zm0 4h-6c-.2652 0-.5196-.1054-.7071-.2929S20 43.2652 20 43c0-.2652.1054-.5196.2929-.7071S20.7348 42 21 42h6c.2652 0 .5196.1054.7071.2929S28 42.7348 28 43c0 .2652-.1054.5196-.2929.7071S27.2652 44 27 44Zm8-12c-.2652 0-.5196-.1054-.7071-.2929S34 31.2652 34 31v-2c0-.2652.1054-.5196.2929-.7071S34.7348 28 35 28c.2652 0 .5196.1054.7071.2929S36 28.7348 36 29v2c0 .2652-.1054.5196-.2929.7071S35.2652 32 35 32Zm0 6c-.2652 0-.5196-.1054-.7071-.2929S34 37.2652 34 37v-2c0-.2652.1054-.5196.2929-.7071S34.7348 34 35 34c.2652 0 .5196.1054.7071.2929S36 34.7348 36 35v2c0 .2652-.1054.5196-.2929.7071S35.2652 38 35 38Zm4-6c-.2652 0-.5196-.1054-.7071-.2929S38 31.2652 38 31v-2c0-.2652.1054-.5196.2929-.7071S38.7348 28 39 28c.2652 0 .5196.1054.7071.2929S40 28.7348 40 29v2c0 .2652-.1054.5196-.2929.7071S39.2652 32 39 32Zm0 6c-.2652 0-.5196-.1054-.7071-.2929S38 37.2652 38 37v-2c0-.2652.1054-.5196.2929-.7071S38.7348 34 39 34c.2652 0 .5196.1054.7071.2929S40 34.7348 40 35v2c0 .2652-.1054.5196-.2929.7071S39.2652 38 39 38Zm-4 6c-.2652 0-.5196-.1054-.7071-.2929S34 43.2652 34 43v-2c0-.2652.1054-.5196.2929-.7071S34.7348 40 35 40c.2652 0 .5196.1054.7071.2929S36 40.7348 36 41v2c0 .2652-.1054.5196-.2929.7071S35.2652 44 35 44Zm4 0c-.2652 0-.5196-.1054-.7071-.2929S38 43.2652 38 43v-2c0-.2652.1054-.5196.2929-.7071S38.7348 40 39 40c.2652 0 .5196.1054.7071.2929S40 40.7348 40 41v2c0 .2652-.1054.5196-.2929.7071S39.2652 44 39 44Z",
            fill: theme.vars.palette.secondary.main
          }
        )
      ]
    }
  );
}
CorporateCompany.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "CorporateCompany"
};
validateTidalLicense();
export {
  CorporateCompany
};
//# sourceMappingURL=CorporateCompany.js.map
